/// Result of `POST /v1/auth/email-status`.

export interface EmailStatus {
  /// `new` | `password` | `social`
  status: string;
  providers: string[];
  username: string;
}

export function emailStatusFromJson(json: Record<string, unknown>): EmailStatus {
  const rawProviders = json.providers;
  const providers: string[] = [];
  if (Array.isArray(rawProviders)) {
    for (const item of rawProviders) {
      if (typeof item === 'string' && item.length > 0) providers.push(item);
    }
  }
  return {
    status: typeof json.status === 'string' ? json.status : 'new',
    providers,
    username: typeof json.username === 'string' ? json.username : '',
  };
}

export function isNewEmail(status: EmailStatus): boolean {
  return status.status === 'new';
}

export function hasPasswordEmail(status: EmailStatus): boolean {
  return status.status === 'password';
}

export function hasGoogle(status: EmailStatus): boolean {
  return status.providers.includes('google');
}

export function hasApple(status: EmailStatus): boolean {
  return status.providers.includes('apple');
}
